import React, { useState, useRef } from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { CContainer, CHeader, CHeaderBrand, CHeaderDivider, CCard, CCardBody, CHeaderNav, CHeaderToggler, CButtonGroup, CButton, CCol, CRow, CFormCheck, CNavLink, CNavItem } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilBell, cilEnvelopeOpen, cilList, cilMenu, cilX } from '@coreui/icons'
import { AppBreadcrumb } from './index'
import { useHistory } from 'react-router-dom'
import './AppHeader.css'

import { AppHeaderDropdown } from './header/index'
import { useEffect } from 'react'
import { useSidebar } from './SidebarContext'
import { getStoredAppRole } from '../utils/handleCookie'

const AppHeader = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const { isSidebarOpen, toggleSidebar, closeSidebar, openSidebar } = useSidebar()

  const handleOnClick = (e) => {
    window.ActiveSelection = !window.ActiveSelection

    if (e.target.id == 'b1') {
      history.push('/home/patient')
    } else {
      history.push('/dashboard/callcenter')
    }
  }

  const role = getStoredAppRole()
  const isCallCenterRole = role === 'callcenter'

  return (
    <CHeader position="sticky" style={{ marginBottom: '0px !important', minHeight: '65px' }} className="header-dark app-shell-header">
      <CContainer fluid>
        {role !== 'provider' && !isCallCenterRole && (
          <CHeaderToggler className="ps-1 app-shell-toggler" onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}>
            <CIcon icon={cilMenu} size="lg" className="app-shell-icon" />
          </CHeaderToggler>
        )}
        {role === 'provider' && (
          <CHeaderToggler
            className="ps-1 toggleButtonProvider app-shell-toggler"
            onClick={() => {
              toggleSidebar()
            }}
          >
            <CIcon icon={isSidebarOpen ? cilX : cilMenu} size="lg" className="app-shell-icon" />
          </CHeaderToggler>
        )}
        {/*         
        <CRow >
          <CCol >
          <CCard className="shadow-lg bg-body appheader" >
            <CCardBody> 
            <CButtonGroup onClick={handleOnClick}>
 
 <CButton id="b1"   color="primary"   variant="outline"  active={window.ActiveSelection}>
Patient Tracking  </CButton>
 <CButton id="b2"  color="primary"  variant="outline"  active={!window.ActiveSelection}>
   Call Center
 </CButton>
</CButtonGroup>
              
            </CCardBody>
            </CCard>
          </CCol>
        </CRow> */}
        <CHeaderNav>
          {/* <CNavItem>
            <CNavLink href="#">
              <CIcon icon={cilBell} size="lg" />
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">
              <CIcon icon={cilList} size="lg" />
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">
              <CIcon icon={cilEnvelopeOpen} size="lg" />
            </CNavLink>
          </CNavItem> */}
        </CHeaderNav>

        <CHeaderNav className="ms-3">
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
